import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DevExpressModule } from '../../devexpress.module';
import { SharedModule } from '../../shared/shared.module';
import { OrderRoutingModule } from './order-routing.module';
import { OrdersComponent } from './pages/orders/orders.component';
import { OrderComponent } from './pages/order/order.component';
import { AttrDateComponent } from '../../shared/components/order/attr-date/attr-date.component';

@NgModule({
  imports: [CommonModule, TranslateModule, OrderRoutingModule, SharedModule, DevExpressModule],
  declarations: [OrdersComponent, OrderComponent, AttrDateComponent],
  exports: [],
})
export class OrderModule {}
